module.exports = __webpack_public_path__ + "img/icon_heart_full_red.b7f8365d.svg";